var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"size":"xl","title":"Crear Ubicaciones","hide-footer":"","centered":""},model:{value:(_vm.modal.ver),callback:function ($$v) {_vm.$set(_vm.modal, "ver", $$v)},expression:"modal.ver"}},[(_vm.modal.paso == 0 )?_c('crear'):_vm._e(),(_vm.modal.paso == 1)?_c('enlazar',{attrs:{"asociar":_vm.asociar}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }